import request from '@/utils/request'
export function GetData(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetHeadList',
        method: 'post',
        params: data
    })
}
export function getUserManualALLList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/API/HomeQuery/ListALL',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/head.js